import '@stripe/stripe-js';
import React, { lazy, Suspense } from 'react';
import { render } from 'react-dom'; // todo: fix, this is deprecated; see https://react.dev/blog/2022/03/08/react-18-upgrade-guide#updates-to-client-rendering-apis
import { Provider } from 'react-redux';
import { Route, Router, Switch } from 'react-router-dom';
import '../public/scss/main.scss';
import PublicApp from './PublicApp/PublicApp';
import { MapViewProvider } from './components/mapView/mapViewContext';
import { startListener } from './events/serviceWorkerEventListener';
import App from './pages/App';
import history from './routes/history';
import registerServiceWorker from './serviceWorkers/registerServiceWorker';
import { store } from './utilities';
import { setupInterceptors } from './utilities/api';
import PrivateRoute from './mp/components/PrivateRoute';
// import NewRealtimeMapPage from './mp/pages/new';
// import RealtimeMapPage from './mp/pages/mp';
import routes from './routes/constants';
import PreviewTestPage from './pages/previewTest';
import Loading from './components/loading/Loading';
import Onboarding from './pages/dashboard/components/onboarding';
setupInterceptors(store);
var RealtimeMapPage = /*#__PURE__*/ lazy(function() {
    return import('./mp/pages/mp');
});
var NewRealtimeMapPage = /*#__PURE__*/ lazy(function() {
    return import('./mp/pages/new');
});
render(/*#__PURE__*/ React.createElement(Provider, {
    store: store
}, /*#__PURE__*/ React.createElement(Router, {
    history: history
}, /*#__PURE__*/ React.createElement(Suspense, {
    fallback: /*#__PURE__*/ React.createElement(Loading, null)
}, /*#__PURE__*/ React.createElement(Switch, null, /*#__PURE__*/ React.createElement(PrivateRoute, {
    exact: true,
    path: routes.mp.job(),
    component: RealtimeMapPage
}), /*#__PURE__*/ React.createElement(PrivateRoute, {
    exact: true,
    path: routes.mp.root,
    component: NewRealtimeMapPage
}), /*#__PURE__*/ React.createElement(Route, {
    exact: true,
    path: "/preview-test",
    component: PreviewTestPage
}), /*#__PURE__*/ React.createElement(MapViewProvider, null, /*#__PURE__*/ React.createElement(Route, {
    path: "/embed",
    component: PublicApp
}), /*#__PURE__*/ React.createElement(Route, {
    path: "/",
    component: App
}))))), /*#__PURE__*/ React.createElement(Onboarding, null)), document.getElementById('root'));
if (process.env.ENABLE_SERVICE_WORKER) {
    startListener();
    registerServiceWorker();
}
